<template>
  <div class="orderContract">
    <HeaderSearch @getSearchValue="getSearchValue" />
    <div v-if="isShowData" class="bindEnterprise_img">
      <img src="@/assets/images/nodata.png" alt="">
      <span>暂无数据</span>
    </div>
    <ContractList :contractData="contractData" v-if="contractData.length > 0" />
    <div v-if="isShowBtn" class="realNameAuth_btn realNameAuth_card" @click="bindReturn">返回</div>
  </div>
</template>

<script>
import HeaderSearch from './headerSearch.vue';
import ContractList from './contractList.vue';

export default {
  name: 'OrderContract',
  components: {
    HeaderSearch,
    ContractList,
  },
  data() {
    return {
      contractData: [],
      isShowData: false,
      isShowBtn: false,
      search: {
        contractType: '2', // 1-其他协议 ，2-订单协议
        name: '',
      },
    };
  },
  mounted() {
    this.queryAllContract();
  },
  methods: {
    async queryAllContract() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
      });
      try {
        const res = await this.$api.PublicPage.queryAllContract({ ...this.search });
        if (res.success) {
          this.contractData = res.data;
          if (res.data.length === 0) {
            this.isShowData = true;
          } else {
            this.isShowData = false;
          }
          this.$toast.clear();
        } else {
          this.$toast.clear();
          this.contractData = [];
          this.isShowData = true;
        }
        this.isShowBtn = true;
      } catch (err) {
        this.$toast.clear();
      }
    },
    getSearchValue(val) {
      this.search.name = val;
      this.queryAllContract();
    },
    bindReturn() {
      this.$router.push(
        '/supermarket/v2/personalCenter',
      );
    },
  },
};
</script>
<style scoped>
.bindEnterprise_img{
  width: 100%;
  height: 280px;
  overflow: hidden;
  margin-top: 30px;
}
.bindEnterprise_img img{
  width: 100%;
  height: 100%;
}
.bindEnterprise_img span {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  letter-spacing: 0;
  text-align: center;
  margin-top: -90px;
}
.realNameAuth_btn {
  height: 44px;
  margin: 20px 16px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.realNameAuth_card {
  background: #ff6538;
}
</style>
